import { Link } from 'react-router-dom'

export function Thanks() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="card max-w-lg text-center">
        <h1 className="text-2xl font-bold mb-2">Thank you!</h1>
        <p className="text-gray-600 mb-6">Your responses were submitted. Your advisor will review and follow up with next steps.</p>
        <Link to="/" className="btn-primary">Return Home</Link>
      </div>
    </div>
  )
}


